import React from 'react';
import { Dialog } from 'evergreen-ui';

/** Компонент-Диалог для удаления каких-либо данных
 * @param {string} title название диалогового окна
 * @param {JSX.Element} children тело диалога
 * @param {Function} closeDialog то, что должно происходить при закрытии диалога
 * @param {Function} onConfirm то, что происходит при надатии на кнопку "Удалить".
 * в эту функцию передается:
 * стандартная функция закрытия диалога close();
 * функция обозначения процесса удаления setIsDeleting, которая принимает true или false.
 * @example
 * isShowDialog && <DeleteDialog
 *    title="Удалить Что-то"
 *    onConfirm={(close, setIsDeleting) => {
 *      setIsDeleting(true) // если нужно обозначить, что идет удаление
 *      // какие-то действия удаления
 *       close() // если нужно закрыть диалог по окончании действий
 *    }}
 *    closeDialog={() => setIsShownDeleteDialog(false)}
 *  >
 *     <p>some text</p> // это children
 *  </DeleteDialog>
 * Пояснения к пример. Почему используется isShowDialog && <DeleteDialog /> ?
 * Потому что так диалог не вызывается при каждом рендере, если он закрыт
 * но можно и как обычно указывать isShown, но так диалог будет перерисовываться при каждом рендере
 */

type DeleteDialogProps = React.PropsWithChildren<{
  title: string
  closeDialog: () => void
  onConfirm: (close: () => void, setIsDeleting: React.Dispatch<React.SetStateAction<boolean>>) => void
  isDeletingProp?: boolean
  isShown?: boolean
}>;

export default function DeleteDialog({
  isShown = true, title, closeDialog, onConfirm, isDeletingProp, children,
}: DeleteDialogProps) {
  const [isDelLegacy, setIsDeleting] = React.useState(false);
  const isDeleting = isDeletingProp || isDelLegacy;
  const onConfirmDialog = React.useCallback((close: () => void) => {
    if (onConfirm) {
      onConfirm(close, setIsDeleting);
    }
  }, [onConfirm]);

  return (
    <Dialog
      isShown={isShown}
      title={title}
      onCloseComplete={closeDialog}
      isConfirmLoading={isDeleting}
      onConfirm={onConfirmDialog}
      intent="danger"
      confirmLabel="Удалить"
      cancelLabel="Отмена"
      shouldCloseOnOverlayClick={false}
    >
      <div>{children}</div>
    </Dialog>
  );
}
